import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import App from './views/containers/App'
import configureStore from './core/store'

import './index.css'

const store = configureStore()
// todo: move all of this to a test suite
// store.dispatch(actions.changeTotalPreTax(126.89))
// store.dispatch(actions.changeTaxCost(12.05))
// store.dispatch(actions.changeTipCost(25.5))
// store.dispatch(actions.addItem({name: 'crispy rice', price: 21.98, split: 4}))
// store.dispatch(actions.addItem({name: 'philadelphia roll', price: 27.98, split: 4}))
// store.dispatch(actions.removeItem(0))


export default class Root extends React.Component {
  render () {
    return (
      <Provider store={store}>
        <App />
      </Provider>
    )
  }
}

ReactDOM.render(
  <Root />,
  document.getElementById('root')
)



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/